
export class Pais {

    id: number;
    nombre: string;
    isoPais : string;
    iso3Pais: string;
    codigoTelefonicoPais: string;
    factorDeRiesgo: number;
    


    /**
     * Constructor
     *
     * @param pais
     */
    constructor(pais)
    {
        {
            this.id = pais.id || null;
            this.nombre = pais.nombre || '';
            this.isoPais = pais.isoPais || '';
            this.iso3Pais = pais.iso3Pais || '';
            this.codigoTelefonicoPais = pais.codigoTelefonicoPais || '';
            this.factorDeRiesgo = pais.factorDeRiesgo || 0;
        }
    }
}
